// Angular Imports
// =========================================================
import { Component, ViewChild, type OnDestroy, type OnInit } from '@angular/core'
// Angular Material Imports
// =========================================================
// Prime NG Imports
// =========================================================
// Custom Imports
// =========================================================
// JSON Data
// =========================================================
import $recoBuyQty from 'src/app/05_ag-grid-configs/01_json-grid-configs/reco-buy-qty/colDefs-reco-buy-qty.json'

// import $recoBuyQtyJSON from '../../../05_ag-grid-configs/01_json-grid-configs/colDefs-main-job-upload.json'
import {
  type SelectionChangedEvent,
  type GridApi,
  type GridReadyEvent,
  type RowNode,
  type CellClickedEvent,
  type IStatusPanelParams,
  type CellValueChangedEvent,
  type RowClassParams
} from 'ag-grid-community'
import { DialogService } from 'primeng/dynamicdialog'
import { RecoBuyQtyUploadModalComponent } from 'src/app/04_modals/review-orders/reco-buy-qty-modal/reco-buy-qty-modal.component'
import { RecoBuyQty_GenerateGridData } from 'src/app/05_ag-grid-configs/04_generate-colDefs/reco-buy-qty-colDefs'
import { CustomGridOptions, DefaultGridContextMenu } from 'src/app/05_ag-grid-configs/02_global-settings/grid-options'
import { MatSidenav } from '@angular/material/sidenav'
import { RecoBuyQtyAPIs } from 'src/app/core/apis/reco-buy-qty_api-calls'
import { cloneDeep, random } from 'lodash'
import { RecoBuyQtySubmitModalComponent } from 'src/app/04_modals/review-orders/reco-buy-qty-submit-modal/reco-buy-qty-submit-modal.component'
import { RecoBuyQtyRepoModalComponent } from 'src/app/04_modals/review-orders/reco-buy-qty-repo-modal/reco-buy-qty-repo-modal.component'
import { SaveGridState } from 'src/app/05_ag-grid-configs/02_global-settings/grid-functions-general'
import { GeneralAPIs } from 'src/app/core/apis/general_api-calls'
import { type AGGrigSavedSettingsInterface } from 'src/app/core/interfaces/ag-grid-saved-settings-interface'
import { RecoBuyQtyStatusBarComponent } from './reco-buy-qty-status-bar/reco-buy-qty-status-bar.component'

interface RecoBuyQtyRow {
  id: string
  plan_id?: number
  plan_name: string
  max_plan_retail_cost?: number
  season: string
  profile_gen: string
  reco_quantification: null
  created_at: string
  created_by: string
  last_modified_at?: string
  last_modified_by?: string
  row_id: number
  lvl_6_from_bottom: string
  lvl_6_from_bottom_name?: string
  lvl_5_from_bottom: string
  lvl_5_from_bottom_name?: string
  lvl_4_from_bottom: string
  lvl_4_from_bottom_name?: string
  style_id: string
  style_name?: string
  styc_id: string
  styc_name?: string
  color_family: string
  attr_1: string
  value_1: string
  attr_2: string
  value_2: string
  attr_3: string
  value_3: string
  retail_cost: number
  retail_price: number
  ecomm_size_range?: string
  stores_size_range?: string
  store_distro?: string
  moq: number
  ecomm_tgt_qty?: number
  stores_tgt_qty?: number
  total_tgt_qty?: number
  ecomm_demand_qty?: number
  stores_demand_qty?: number
  ttl_demand_qty?: number
  ecomm_reco_qty?: number
  stores_reco_qty?: number
  ttl_reco_qty?: number
  ecomm_reco_price?: number
  stores_reco_price?: number
  rationale?: string
  locked: boolean
  status: string
  hasChanges?: boolean
}

interface RecoBuyQtyStatusBarParams extends IStatusPanelParams {
  statusPanelParams: {
    maxBudget: number
  }
}

@Component({
  standalone: false,
  selector: 'app-reco-buy-qty',
  templateUrl: './reco-buy-qty.component.html',
  styleUrls: ['./reco-buy-qty.component.scss']
})
export class RecoBuyQtyComponent implements OnInit, OnDestroy {
  @ViewChild('sidenav') sidenav: MatSidenav
  // public recoBuyQty = $recoBuyQtyJSON
  selectedStatus: string = 'All'
  repoOriginalRowData: any[] = []
  repoSearchText = ''
  storedGridSettings: AGGrigSavedSettingsInterface = {}

  assortmentPlanName: string
  buyingSeason: string
  maxPlanRetailCost: string = '0'
  plan: any
  hasChanges = false

  gridName = 'reco_buy_qty'

  rowData: RecoBuyQtyRow[] = []
  pinnedBottomRowData: any[] = []
  originalRowData: RecoBuyQtyRow[] = []
  columnDefs = []
  repoRowData: any[] = []
  repoColumnDefs = []
  statusBar: {}

  gridActionsEnabled = {
    approve: false,
    reject: false,
    lock: false,
    unlock: false,
    submit: false,
    reset: false,
    exportCSV: true,
    exportExcel: true
  }

  menuSplitButtonDisabled = true
  loading = false
  repoLoading = true
  selectedRows: RecoBuyQtyRow[] = []
  gridOptions = {
    ...CustomGridOptions,
    context: {
      componentParent: this,
      deletePlanLine: params => this.deletePlanLine(params)
    },
    defaultColDef: {
      autoHeaderHeight: true,
      wrapHeaderText: true
    },

    // noRowsOverlayComponent: RecoBuyQtyGridOverlayComponent,
    noRowsOverlayComponentParams: {
      openUploadPlanModal: () => this.openUploadPlanModal(),
      openRepositoryModal: () => this.openRepositoryModal()
    },
    getContextMenuItems: params => [
      {
        name: 'Save Grid View',
        action: async () => {
          await SaveGridState(this.gridApi, params, 'reco_buy_qty', true)
        },
        cssClasses: ['text-accent']
      },
      'separator',
      ...DefaultGridContextMenu(params)
    ],
    onSelectionChanged: (event: SelectionChangedEvent) => this.onSelectionChanged(event),
    quickFilterParser: (quickFilter: string) => [quickFilter],
    quickFilterMatcher: (quickFilterParts: string[], rowQuickFilterAggregateText: string, rowNode: any) => {
      console.log('quickFilterParts', rowQuickFilterAggregateText)
      console.log('rowNode', rowNode)
      const cols = rowQuickFilterAggregateText.split(/\n/)
      // cols.splice(10) // we only want to match on the first 10 columns.
      // this order stays the same even if the user rearranges columns, so we can just use index
      rowQuickFilterAggregateText = cols.join('')
      console.log('matching on cols', cols)
      return quickFilterParts.every(part => rowQuickFilterAggregateText.match(part))
    },
    getRowId: (node: RowNode) => {
      return node.data.row_id
    },
    // grandTotalRow: 'bottom',
    onCellValueChanged: (event: CellValueChangedEvent) => this.onCellValueChanged(event),
    getRowStyle: (params: RowClassParams) => {
      if (params.data?.hasChanges) {
        return {
          backgroundColor: '#22c55f88' // accent-success at half transparency
        }
      } else if (!params.data) {
        // total row
        return {
          fontWeight: 'bold'
        }
      }
    }
    // onFirstDataRendered: () => this.createTotalRow()
  }

  public recoBuyQty = $recoBuyQty

  gridApi: GridApi
  repoGridApi: GridApi

  constructor (
    public dialogService: DialogService,
    public recoBuyQtyApi: RecoBuyQtyAPIs,
    private readonly generalAPIs: GeneralAPIs
  ) {
    // this.recoBuyQtyApi.GetAllPlans().then(response => {
    //   this.recoBuyQtyApi.onSetRecoPlans(response.data)
    // })
    this.recoBuyQtyApi.GetAllSeasons().then(response => {
      this.recoBuyQtyApi.onSetSeasons(response.data)
    })
  }

  ngOnInit (): void {
    this.statusBar = {
      statusPanels: [
        {
          statusPanel: RecoBuyQtyStatusBarComponent,
          align: 'left',
          key: 'recoBuyQtyStatusBar'
        },
        {
          statusPanel: 'agTotalAndFilteredRowCountComponent'
        }
      ]
    }
  }

  // onGridReady (event: GridReadyEvent) {
  //   this.gridApi = event.api

  //   RecoBuyQty_GenerateGridData({ mainColDefs: this.recoBuyQty[0] as any }).then(data => {
  //     this.columnDefs = data.mainColDefs
  //   })
  // }

  async onGridReady (event: GridReadyEvent) {
    this.gridApi = event.api

    const data = await RecoBuyQty_GenerateGridData({
      mainColDefs: this.recoBuyQty[0] as any
    })
    this.columnDefs = data.mainColDefs

    const savedState = await this.generalAPIs.GetGridView(this.gridName)
    if (savedState?.is_success && savedState.data) {
      this.storedGridSettings[this.gridName] = savedState.data
    } else {
      this.storedGridSettings[this.gridName] = { colDefs: [], filters: {}, externalFilters: null }
    }

    setTimeout(() => {
      const colState = this.storedGridSettings[this.gridName]?.colDefs || []
      if (colState.length > 0) {
        this.gridApi.applyColumnState({ state: colState, applyOrder: true })
      }

      // Apply filters
      const filterModel = this.storedGridSettings[this.gridName]?.filters || {}
      this.gridApi.setFilterModel(filterModel)
    }, 100)
  }

  onCellValueChanged (event: CellValueChangedEvent) {
    console.log('on Cell Value Changed', event)
    const newData = { ...event.node.data, hasChanges: true }
    // Recompute the stored reco cost/price (and total reco qty) from the edited
    // quantities. The pinned TOTAL row sums these stored fields, so without this
    // the cost/price totals stay stale after a qty edit.
    this.recalcRecoCostPrice(newData)
    event.node.setData(newData)
    const idx = this.rowData.findIndex(r => r.row_id === event.node.data.row_id)
    if (idx !== -1) this.rowData[idx] = newData
    this.hasChanges = true
    this.createTotalRow()
    this.gridApi.refreshCells({ rowNodes: [event.node], force: true })
    this.onSelectionChanged({ api: this.gridApi })
  }

  // Recompute the derived reco cost/price (and total reco qty) for a row from its
  // current quantities, mirroring the formulas used when a plan is loaded. These
  // stored fields back the pinned TOTAL row sums and must be kept in sync on edit.
  recalcRecoCostPrice (row) {
    const ecommRecoQty = row.ecomm_reco_qty || 0
    const storesRecoQty = row.stores_reco_qty || 0
    const retailCost = row['retail_cost_($)'] || 0
    const retailPrice = row['retail_price_($)'] || 0
    const ttlRecoQty = ecommRecoQty + storesRecoQty

    row.ttl_reco_qty = ttlRecoQty
    row['ecomm_reco_cost_($)'] = Math.round(ecommRecoQty * retailCost)
    row['stores_reco_cost_($)'] = Math.round(storesRecoQty * retailCost)
    row['total_reco_cost_($)'] = Math.round(ttlRecoQty * retailCost)
    row['ecomm_reco_price_($)'] = Math.round(ecommRecoQty * retailPrice)
    row['stores_reco_price_($)'] = Math.round(storesRecoQty * retailPrice)
    row['total_reco_price_($)'] = Math.round(ttlRecoQty * retailPrice)
  }

  openRepositoryModal () {
    this.recoBuyQtyApi.GetAllPlans().then(response => {
      this.recoBuyQtyApi.onSetRecoPlans(response.data)
    })
    const ref = this.dialogService.open(RecoBuyQtyRepoModalComponent, {
      showHeader: false,
      closeOnEscape: true,
      dismissableMask: true,
      styleClass: 'medium-modal',
      data: {
        deletePlan: (callback: Function, planName: string) => this.onDelete(callback, planName)
      }
    })

    ref.onClose.subscribe(data => {
      if (!data) return
      this.loading = true
      this.recoBuyQtyApi.GetPlan(data).then(response => {
        this.assortmentPlanName = response.data.plan_name
        this.buyingSeason = response.data.season
        response.data.rows.forEach(row => {
          row['retail_cost_($)'] = row.retail_cost
          delete row.retail_cost
          row['retail_price_($)'] = row.retail_price
          delete row.retail_price
          row['ecomm_reco_cost_($)'] = Math.round(row.ecomm_reco_qty * row['retail_cost_($)'])
          row['stores_reco_cost_($)'] = Math.round(row.stores_reco_qty * row['retail_cost_($)'])
          row['stores_reco_price_($)'] = Math.round(row.stores_reco_qty * row['retail_price_($)'])
          row['ecomm_reco_price_($)'] = Math.round(row.ecomm_reco_qty * row['retail_price_($)'])
          row['total_reco_cost_($)'] = Math.round(
            (row['ecomm_reco_qty'] + row['stores_reco_qty']) * row['retail_cost_($)']
          )
          row['total_reco_price_($)'] = Math.round(
            (row['ecomm_reco_qty'] + row['stores_reco_qty']) * row['retail_price_($)']
          )
          row.sty_name = row.style_name
          delete row.style_name
        })
        this.rowData = response.data.rows
        this.createTotalRow()

        this.updateStatusBar(this.rowData[0].max_plan_retail_cost)

        this.originalRowData = cloneDeep(response.data.rows)
        this.loading = false
      })
    })
  }

  openUploadPlanModal () {
    const ref = this.dialogService.open(RecoBuyQtyUploadModalComponent, {
      showHeader: false,
      closeOnEscape: true,
      dismissableMask: true,
      styleClass: 'medium-modal',
      data: {}
    })
    ref.onClose.subscribe(data => {
      console.log('data from modal', data)
      if (data) {
        this.loading = true
        this.originalRowData = cloneDeep(data.fileData)
        this.assortmentPlanName = data.formData.planNameControl
        this.buyingSeason = data.formData.buyingSeasonControl
        this.maxPlanRetailCost = data.formData.maxPlanRetailCostControl
        data.fileData.forEach(row => {
          row['retail_cost_($)'] = parseFloat(row['retail_cost_($)'].split(',').join(''))
          row['retail_price_($)'] = parseFloat(row['retail_price_($)'].split(',').join(''))
        })
        const plan = {
          plan_name: this.assortmentPlanName,
          season: this.buyingSeason,
          max_plan_retail_cost: this.maxPlanRetailCost,
          plan_lines: data.fileData
        }

        this.recoBuyQtyApi
          .UploadPlan(plan)
          .then(response => {
            data.fileData.forEach(row => {
              row['row_id'] = response.data[row.id]
              row['status'] = 'NEW'
              row['ecomm_demand_qty'] = 0
              row['stores_demand_qty'] = 0
              row['total_demand_qty'] = 0
              row['ecomm_reco_qty'] = 0
              row['stores_reco_qty'] = 0
              row['total_reco_qty'] = 0
              row['moq'] = parseFloat(row.moq)
            })
            this.rowData = data.fileData
            this.createTotalRow()
            this.updateStatusBar(this.maxPlanRetailCost)
            if (data.formData.runAfterSaveControl) {
              this.runBuyReco()
            }
            // this.recoBuyQtyApi.GetAllPlans().then(response => {
            //   this.recoBuyQtyApi.onSetRecoPlans(response.data)
            // })
          })
          .finally(() => {
            this.loading = false
          })
      }
    })
  }

  updateStatusBar (budget) {
    if (this.gridApi) {
      const statusBar = this.gridApi.getStatusPanel('recoBuyQtyStatusBar')
      if (statusBar && statusBar.refresh) {
        statusBar.refresh({
          statusPanelParams: { maxBudget: budget }
        } as RecoBuyQtyStatusBarParams)
      }
    }
  }

  onSelectionChanged (event: SelectionChangedEvent | { api: GridApi }) {
    const rows = event.api.getSelectedNodes().map(row => row.data)

    const isRowSelected = rows.length > 0
    this.selectedRows = rows
    this.gridActionsEnabled.approve = isRowSelected && !this.hasChanges
    this.gridActionsEnabled.reject = isRowSelected && !this.hasChanges
    this.gridActionsEnabled.lock = isRowSelected
    this.gridActionsEnabled.unlock = isRowSelected
    this.gridActionsEnabled.reset = isRowSelected
    let canSubmit = true
    this.selectedRows.forEach(row => {
      if (row.status !== 'APPROVED') {
        canSubmit = false
      }
    })
    this.gridActionsEnabled.submit = isRowSelected && canSubmit
  }

  onDelete (callback?: Function, planName = this.assortmentPlanName) {
    this.recoBuyQtyApi.DeletePlan(planName).then(response => {
      callback()
    })
  }

  deletePlanLine (params: CellClickedEvent) {
    this.loading = true
    this.recoBuyQtyApi
      .DeletePlanLines(this.assortmentPlanName, params.data.row_id)
      .then(response => {
        this.gridApi.applyTransaction({
          remove: [{ row_id: params.data.row_id }]
        })
        // Keep the component's rowData in sync with the grid so the pinned
        // bottom TOTAL row (computed from this.rowData) reflects the deletion.
        this.rowData = this.rowData.filter(row => row.row_id !== params.data.row_id)
        this.createTotalRow()
      })
      .finally(() => {
        this.loading = false
      })
  }

  createProfiles () {}

  runBuyReco () {
    console.log('running buy reco for plan', this.assortmentPlanName)
    this.recoBuyQtyApi.RunBuyReco(this.assortmentPlanName).then(response => {
      //
    })
  }

  createTotalRow () {
    if (!this.rowData || this.rowData.length === 0) {
      this.pinnedBottomRowData = []
      return
    }
    const total = {
      // 'retail_cost_($)': undefined,
      // 'retail_price_($)': 0,
      moq: 0,
      ecomm_tgt_qty: 0,
      stores_tgt_qty: 0,
      ecomm_demand_qty: 0,
      stores_demand_qty: 0,
      ttl_demand_qty: 0,
      ecomm_reco_qty: 0,
      stores_reco_qty: 0,
      ttl_reco_qty: 0,
      'ecomm_reco_cost_($)': 0,
      'stores_reco_cost_($)': 0,
      'total_reco_cost_($)': 0,
      'ecomm_reco_price_($)': 0,
      'stores_reco_price_($)': 0,
      'total_reco_price_($)': 0,
      store_distro: 'TOTAL', // optional label
      __isTotalRow: true // flag to identify total row
    }
    this.rowData.forEach(row => {
      // total['retail_cost_($)'] += row['retail_cost_($)'] || 0
      // total['retail_price_($)'] += row['retail_price_($)'] || 0
      total.moq += row.moq || 0
      total.ecomm_tgt_qty += row.ecomm_tgt_qty || 0
      total.stores_tgt_qty += row.stores_tgt_qty || 0
      total.ecomm_demand_qty += row.ecomm_demand_qty || 0
      total.stores_demand_qty += row.stores_demand_qty || 0
      total.ttl_demand_qty += row.ttl_demand_qty || 0
      total.ecomm_reco_qty += row.ecomm_reco_qty || 0
      total.stores_reco_qty += row.stores_reco_qty || 0
      total.ttl_reco_qty += row.ttl_reco_qty || 0
      total['ecomm_reco_cost_($)'] += row['ecomm_reco_cost_($)'] || 0
      total['stores_reco_cost_($)'] += row['stores_reco_cost_($)'] || 0
      total['total_reco_cost_($)'] += row['total_reco_cost_($)'] || 0
      total['ecomm_reco_price_($)'] += row['ecomm_reco_price_($)'] || 0
      total['stores_reco_price_($)'] += row['stores_reco_price_($)'] || 0
      total['total_reco_price_($)'] += row['total_reco_price_($)'] || 0
    })

    // this.pinnedBottomRowData = [total]
    this.gridApi.setGridOption('pinnedBottomRowData', [total])
    // this.rowData.push(total)
    return total
  }

  onApprove (event) {
    this.loading = true
    console.log('getselectedrows', this.gridApi.getSelectedRows())
    console.log('getselectednodes', this.gridApi.getSelectedNodes())
    const row_ids = this.selectedRows.map(row => row.row_id)
    this.recoBuyQtyApi
      .ApproveRows({
        plan_name: this.assortmentPlanName,
        row_ids
      })
      .then(response => {
        this.gridApi.getSelectedNodes().forEach(node => {
          node.setData({ ...node.data, status: 'APPROVED', locked: true })
        })
        this.gridActionsEnabled.submit = true
      })
      .finally(() => {
        this.loading = false
      })
  }

  onReject (event) {
    this.loading = true
    this.recoBuyQtyApi
      .RejectRows({
        plan_name: this.assortmentPlanName,
        row_ids: this.selectedRows.map(row => row.row_id)
      })
      .then(response => {
        this.gridApi.applyTransaction({
          update: this.selectedRows.map(row => {
            row.status = 'REJECTED'
            row.ecomm_reco_qty = row.ecomm_tgt_qty
            row.stores_reco_qty = row.stores_tgt_qty
            return row
          })
        })
        this.gridActionsEnabled.submit = false
      })
      .finally(() => {
        this.loading = false
      })
  }

  onLock (event) {
    this.loading = true
    this.recoBuyQtyApi
      .changeRowLock({
        plan_name: this.assortmentPlanName,
        updated_rows: this.selectedRows.map(row => row.row_id),
        lock: true
      })
      .then(response => {
        this.gridApi.getSelectedNodes().forEach(node => {
          node.setData({ ...node.data, locked: true })
        })
      })
      .finally(() => {
        this.loading = false
      })
  }

  onUnlock (event) {
    this.loading = true
    this.recoBuyQtyApi
      .changeRowLock({
        plan_name: this.assortmentPlanName,
        updated_rows: this.selectedRows.map(row => row.row_id),
        lock: false
      })
      .then(response => {
        this.gridApi.getSelectedNodes().forEach(node => {
          node.setData({
            ...node.data,
            locked: false,
            status:
                            node.data.status === 'APPROVED' || node.data.status === 'SUBMITTED'
                              ? 'DRAFT'
                              : node.data.status
          })
        })
      })
      .finally(() => {
        this.loading = false
      })
  }

  onReset () {
    const selectedRowIds = this.selectedRows.map(row => row.row_id)
    this.gridApi.applyTransaction({
      update: this.originalRowData
        .filter(row => selectedRowIds.includes(row.row_id))
        .map(row => {
          return {
            ...row,
            hasChanges: false
          }
        })
    })
    this.hasChanges = false
    this.gridApi.redrawRows()
    // this.loading = true
    // this.recoBuyQtyApi.GetPlan(this.assortmentPlanName).then(response => {
    //   this.assortmentPlanName = response.data.plan_name
    //   this.buyingSeason = response.data.season
    //   response.data.rows.forEach(row => {
    //     row['retail_cost_($)'] = row.retail_cost
    //     delete row.retail_cost
    //     row['retail_price_($)'] = row.retail_price
    //     delete row.retail_price
    //     row['ecomm_reco_cost_($)'] = 100
    //     row['stores_reco_cost_($)'] = 200
    //     row.sty_name = row.style_name
    //     delete row.style_name
    //   })
    //   this.rowData = response.data.rows
    // })
  }

  onSubmit () {
    // transform rows
    const submitRows = []
    this.selectedRows.forEach(row => {
      // only generate stores row if stores size range is not null
      if (row.stores_size_range != null && row.stores_size_range != '') {
        submitRows.push({
          row_id: row.row_id + '-stores',
          style_color: row.styc_id,
          channel: 'stores',
          size_range: row.stores_size_range,
          reco_qty: row.stores_reco_qty
        })
      }
      // only generate ecomm row if ecomm size range is not null
      if (row.ecomm_size_range != null && row.ecomm_size_range != '') {
        submitRows.push({
          row_id: row.row_id + '-ecomm',
          style_color: row.styc_id,
          channel: 'ecomm',
          size_range: row.ecomm_size_range,
          reco_qty: row.ecomm_reco_qty
        })
      }
    })
    const ref = this.dialogService.open(RecoBuyQtySubmitModalComponent, {
      showHeader: false,
      closeOnEscape: true,
      dismissableMask: true,
      styleClass: 'medium-modal',
      data: submitRows
    })
    ref.onClose.subscribe(data => {
      if (data) {
        this.recoBuyQtyApi.SubmitRows(data).then(response => {
          const affected_row_ids = data.map(d => d.row_id)
          this.gridApi.getSelectedNodes().forEach(node => {
            if (affected_row_ids.includes(node.data.row_id)) {
              node.setData({ ...node.data, status: 'SUBMITTED', locked: true })
            }
          })
        })
      }
    })
  }

  onProdFilterChange (event) {
    console.log('onprodfilterchange event', event)
    this.gridApi.setGridOption('quickFilterText', event.target.value)
    // this.gridApi.setGridOption('rowData', this.rowData.filter(row => {
    //   return row.prod_lvl_1_id.includes(data) ||
    //     row.prod_lvl_1_name?.includes(data) ||
    //     row.prod_lvl_2_id.includes(data) ||
    //     row.prod_lvl_2_name.includes(data) ||
    //     row.prod_lvl_3_id.includes(data) ||
    //     row.prod_lvl_3_name.includes(data)
    // }))
  }

  savePlan (event) {
    this.gridApi.stopEditing()
    this.loading = true
    const plan = {
      plan_name: this.assortmentPlanName,
      season: this.buyingSeason,
      plan_lines: this.rowData
    }
    this.recoBuyQtyApi.SavePlan(plan).then(response => {
      this.gridApi.forEachNode(node => {
        node.setData({ ...node.data, hasChanges: false })
      })
      this.hasChanges = false
      this.originalRowData = cloneDeep(this.rowData)
      setTimeout(() => {
        this.gridApi.redrawRows()
        this.loading = false
        this.onSelectionChanged({ api: this.gridApi })
      }, 100)
    })
  }

  ngOnDestroy (): void {
    // throw new Error('Method not implemented.')
  }
}
